/**
 * Sandbox Config Store
 */

import { create } from 'zustand';

interface SandboxConfigState {
  /** Currently selected sandbox config name (for detail panel) */
  selectedSandboxConfigName: string | null;
}

interface SandboxConfigActions {
  /** Select a sandbox config by name (for detail panel) */
  selectSandboxConfig: (name: string | null) => void;
  /** Clear all state (e.g., on navigation away) */
  reset: () => void;
}

type SandboxConfigStore = SandboxConfigState & SandboxConfigActions;

const initialState: SandboxConfigState = {
  selectedSandboxConfigName: null,
};

export const useSandboxConfigStore = create<SandboxConfigStore>((set) => ({
  ...initialState,

  selectSandboxConfig: (name) => {
    set({ selectedSandboxConfigName: name });
  },

  reset: () => {
    set(initialState);
  },
}));
